module.exports = __webpack_public_path__ + "img/rotationImgOne.8fcce14d.png";